import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../lib/utils";
import { useCardContext } from "./CardContext";
import { cardHeaderVariants, cardRegionVariants } from "./styles";

export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const CardHeader = ({ className, ref, ...props }: CardHeaderProps) => {
  const { variant, padding } = useCardContext();

  return (
    <div
      ref={ref}
      data-slot="card-header"
      className={cn(cardRegionVariants({ variant, padding }), cardHeaderVariants(), className)}
      {...props}
    />
  );
};
